import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { useSparkRunsStatusTypes } from "hooks/EntityTypes/useSparkRunsStatusTypes";
import MarketplaceSparkRunsHistory from "components/sparkRunHistory/MarketplaceSparkRunsHistory";
import SparkRunsFilters from "./SparkRunsFilters";
import { useCurrentUser } from "hooks/common/useCurrentUser";
import { useAccountUsers } from "hooks/Account/useAccountUsers";
import { useAccountByID } from "hooks/Account/useAccountByID";
import { useMarketplaceAccount } from "hooks/Marketplace/useMarketPlaceAccount";
import { useWorkspaceContext } from "hooks/common/useWorkspaceContext";

const SparkRunListContainer = styled(Box)({
  marginTop: '0',
  width: '100%'
});

const SparkRunsTabContent = () => {
  const [selectedRunStatusID, setSelectedRunStatusID] = useState<string>("all");
  const [runIdFilter, setRunIdFilter] = useState<string>("");
  const theme = useTheme();
  const { sparkRunStatusTypes: statusTypes } = useSparkRunsStatusTypes();
  
  // Get marketplace account ID
  const { currentUserID } = useCurrentUser();
  const { getWorkspace } = useWorkspaceContext();
  const workspace = getWorkspace();
  const { accountIDbyUserIdMap } = useAccountUsers(workspace?.attributes.accountID);
  const { account } = useAccountByID(accountIDbyUserIdMap?.[currentUserID || '']);
  const { marketplaceAccounts } = useMarketplaceAccount(account?.id);
  
  const marketplaceAccount = marketplaceAccounts?.[0];
  const marketplaceAccountId = marketplaceAccount?.id;

  const handleStatusChange = (status: string) => {
    setSelectedRunStatusID(status);
  };

  const handleRunIdChange = (runId: string) => {
    setRunIdFilter(runId);
  };

  return (
    <Box>
      <Box 
        padding="0"
        sx={{
          "@media (max-width: 600px)": {
            padding: "0",
          },
        }}
      >
        <SparkRunsFilters 
          statusTypes={statusTypes}
          selectedStatus={selectedRunStatusID}
          onStatusChange={handleStatusChange}
          onRunIdChange={handleRunIdChange}
          runIdValue={runIdFilter}
        />
      </Box>

      <SparkRunListContainer>
        <Box
          sx={{
            width: '100%',
            "@media (max-width: 600px)": {
              padding: "0",
            },
          }}
        >
          <MarketplaceSparkRunsHistory
            marketplaceAccountId={marketplaceAccountId}
            selectedStatus={selectedRunStatusID}
            runIdFilter={runIdFilter}
            paginatedQuery={{ pageNumber: 1, pageSize: 10 }}
            showPaginationControls={true}
            showAvatarAndName={true}
          />
        </Box>
      </SparkRunListContainer>
    </Box>
  );
};

export default SparkRunsTabContent; 